@if (form().id > 0) {
<div class="flex justify-between">

    <h1 class="mb-8">{{form() | getTranslation:"name":locale()}} </h1>
    <div class="flex gap-1 items-center">
        @if(showLocaleDropdown()) {
        <label>{{strings | getTranslation:"language":locale()}}</label>
        <p-select [(ngModel)]="locale"
            [options]="[{label: 'English', value: 'en'}, {label: 'Español', value: 'es'}]"></p-select>
        }
    </div>
</div>


@if(alreadySubmitted()) {
<p-card>
    <div class=" flex flex-col gap-4">
        <div>{{strings | getTranslation:"already-submitted":locale()}}</div>
        @if(navigation.canGoBack()) {
            <div>
                <p-button (onClick)="navigation.back()">Back</p-button>
            </div>
        }
    </div>
</p-card>
}
@else if (submitted()) {
<p-card>
    <div class=" flex flex-col gap-4">
        <div>{{strings | getTranslation:"response-submitted":locale()}}</div>
        @if (showGoogleReviewLink()) {
            <div class="flex flex-col gap-2">
                <div>{{strings | getTranslation:"google-review-link":locale()}}</div>
                <a href="https://g.page/r/Cc4_pKk_s_i7EBM/review" target="_blank" rel="noopener noreferrer">
                    <div class="flex gap-2 items-center justify-center">
                        <p-button>
                            <span class="p-button-label flex items-center gap-2">
                                {{strings | getTranslation:"leave-review-on-google":locale()}}
                                <fa-icon [icon]="icons.ppmSolid.externalLink"></fa-icon>
                            </span>
                        </p-button>
                    </div>
                </a>
            </div>
        }
    </div>
</p-card>
}
@else {
<div class="flex flex-col gap-8">
    <p-card>
        <div class="instructions">
            {{form() | getTranslation:"instructions":locale()}}
        </div>
    </p-card>

    <p-card>
        <div class="form-container">
            <div>
                <label>{{strings | getTranslation:"trip-date":locale()}}</label>
                <div>{{tripDateRange()}}</div>
            </div>
            <div>
                <label>{{strings | getTranslation:"groups":locale()}}</label>
                <div>
                    <ul class="m-0">
                        @for (group of groupNames(); track $index) {
                        <li>{{group}}</li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    </p-card>


    <form [formGroup]="responseForm" class="mb-8">
        <div formArrayName="questions" class="flex flex-col gap-8 w-full">
            @for (questionForm of responseForm.controls.questions.controls; track questionForm.controls.id.value) {
            @let question = questionMap().get(questionForm.controls.formQuestionId.value);


            <p-card [formGroup]="questionForm">
                @if(question) {
                <div class="question-text mb-4">
                    <div class="">{{question | getTranslation:"text":locale()}}
                        @if(question!.required) {
                        <span class="text-required">*</span>
                        }
                    </div>
                </div>



                @if(question.type === questionTypes.Text) {
                <textarea pTextarea formControlName="text" class="w-full" rows="3"></textarea>
                }
                @else if(question.type === questionTypes.AtlEval || question.type === questionTypes.TlEval) {
                @let staff = staffMap.get(questionForm.controls.staffId.value ?? 0);

                <div class=" ml-4 mb-2 font-bold">{{staff?.first}} {{staff?.last}}</div>

                <div class="grid grid-cols-12 gap-4 w-full">
                    <div class="col-span-3 text-center">{{question | getTranslation:"scaleLow":locale() }}</div>
                    <div class="col-span-6 flex gap-8 justify-center">
                           @let groupId = 'question' + question?.id + '-' + questionForm.controls.id.value + '-radio-group';
                        @for (number of numericScale; track $index) {
                        <div class="flex flex-col items-center">
                            @let inputId = 'question' + question?.id + '-' + questionForm.controls.id.value + '-' +
                            number;
                            <label [for]="inputId">{{number}}</label>
                            <p-radiobutton [formControl]="questionForm.controls.value" [value]="number"
                                [inputId]="inputId" [name]="groupId"></p-radiobutton>
                        </div>
                        }
                    </div>
                    <div class="col-span-3 text-center">{{question | getTranslation:"scaleHigh":locale()}}</div>
                </div>
                }
                @else if (question.type === questionTypes.NumericScale) {
                <div class="grid grid-cols-12 gap-4 w-full">

                    <div class="col-span-3 text-center">{{question | getTranslation:"scaleLow":locale()}}</div>
                    <div class="col-span-6 flex gap-8 justify-center">
                        @let groupId = 'question' + question?.id + '-' + questionForm.controls.id.value + '-radio-group';
                        @for (number of numericScale; track $index) {
                        <div class="flex flex-col items-center">
                            @let inputId = 'question' + question?.id + '-' + questionForm.controls.id.value + '-' +
                            number;
                            <label [for]="inputId">{{number}}</label>
                            <p-radiobutton [formControl]="questionForm.controls.value" [value]="number"
                                [inputId]="inputId" [name]="groupId"></p-radiobutton>
                        </div>
                        }
                    </div>
                    <div class="col-span-3 text-center">{{question | getTranslation:"scaleHigh":locale()}}</div>

                </div>
                }

                @else if (question.type === questionTypes.Numeric) {
                <p-inputnumber formControlName="value"></p-inputnumber>
                }

                @else if (question.type === questionTypes.SingleOptionSelect) {

                <div class="flex flex-col gap-4">
                    @for (option of question.options; track $index) {
                        @let optionId = 'option' + option.id;
                        @let radioGroupName = 'question' + question?.id + '-' + questionForm.controls.id.value + '-radio-group';
                    <div class="flex gap-2">
                        <p-radiobutton [inputId]="optionId" [name]="radioGroupName" [formControl]="questionForm.controls.optionId"
                            [value]="option.id"></p-radiobutton>
                        <label class="cursor-pointer" [for]="optionId">{{option | getTranslation:"text":locale()}}</label>
                        @if(option.allowTextResponse) {
                            <input pInputText [formControl]="questionForm.controls.optionText" />
                        }
                    </div>

                    }
                </div>
                }
                @else if (question.type === questionTypes.MultiOptionSelect) {
                    <div class="flex flex-col gap-4" formArrayName="options">
                        @for(optionForm of questionForm.controls.options.controls; track $index) {
                            @let option = optionMap().get(optionForm.controls.id.value);
                            
                            @if(option) {
                            <div class="flex gap-2" [formGroup]="optionForm">
                                <p-checkbox [inputId]="'option'+option?.id" [binary]="true" formControlName="selected"></p-checkbox>
                                <label [for]="'option'+option?.id">{{option | getTranslation:"text":locale()}}</label>
                                @if(option?.allowTextResponse) {
                                    <input pInputText formControlName="text" />
                                }
                            </div>
                        }
                        }
                    </div>
                }

                }

            </p-card>

            }
        </div>
    </form>
</div>
@if(!loading()) {
<div class="flex justify-end"><p-button (onClick)="submitForm()" [disabled]="submitting()">{{strings | getTranslation:"submit":locale()}}</p-button></div>
}
}
}

@if(loading()) {
<div class="w-full p-8 bg-surface-0 dark:bg-surface-950">
    <div class="flex flex-col gap-8">
        <p-skeleton width="100%" height="15rem"></p-skeleton>
        <p-skeleton width="100%" height="15rem"></p-skeleton>
        <p-skeleton width="100%" height="15rem"></p-skeleton>
    </div>
</div>
}